import axios from '../host';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const unlockSkyPlatform = (studentId) => {
  const body = JSON.stringify({ studentId });
  return axios.post('/api/v2/sky-platform/unlock', body, config);
};

export const updateSkyPlatform = (studentId, skyPlatformPoint) => {
  const body = JSON.stringify({ skyPlatformPoint });
  return axios.post(`/api/v2/students/${studentId}/sky-platform`, body, config);
};

export const getSkyPlatform = (studentId) => {
  return axios.get(`/api/v2/students/${studentId}/sky-platform`, config);
};
